import { createAction, props } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { LimitsModalType, LimitsSummary } from "./limits-reminder.model";

const ACTION_PREFIX = "[Limits reminder]";

/**
 * @deprecated -[fabric-deprecated] - Use limits-reminder-service from app-account instead.
 * */
export namespace LimitsReminderAction {
	export const initializeLimitsReminderType = createAction(
		`${ACTION_PREFIX} initialize limits reminder type ${SYNC_SUFFIX}`
	);

	export const showLimitsReminder = createAction(
		`${ACTION_PREFIX} show limits reminder dialog ${SYNC_SUFFIX}`,
		props<{ payload?: LimitsModalType }>()
	);

	export const fetchBeforeLogout = createAction(`${ACTION_PREFIX} fetch before logout`);

	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimits from app-account instead
	 * */
	export const fetchLimitsSummary = createAction(`${ACTION_PREFIX} fetch limits summary`, (logout?: boolean) => ({
		logout,
	}));

	export const fetchNotificationLimitsSummary = createAction(`${ACTION_PREFIX} fetch notification limits summary`);

	export const fetchNotificationLimitsSummarySuccess = createAction(
		`${ACTION_PREFIX} fetch notification limits summary success`,
		(limitsSummary: LimitsSummary) => ({ limitsSummary })
	);

	export const fetchBeforeLogoutSuccess = createAction(
		`${ACTION_PREFIX} fetch success before logout`,
		(limitsSummary: LimitsSummary) => ({ limitsSummary })
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimits from app-account instead
	 * */
	export const fetchLimitsSummarySuccess = createAction(
		`${ACTION_PREFIX} fetch limits summary success`,
		(limitsSummary: LimitsSummary) => ({ limitsSummary })
	);

	export const fetchBeforeLogoutFailure = createAction(
		`${ACTION_PREFIX} fetch failure before logout`,
		(error: AppError) => ({ error })
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimitsError from app-account instead
	 * */
	export const fetchLimitsSummaryFailure = createAction(
		`${ACTION_PREFIX} fetch limits summary fail`,
		(error: AppError) => ({ error })
	);

	export const gameLaunch = createAction(`${ACTION_PREFIX} game launch ${SYNC_SUFFIX}`, (gameId: string) => ({
		gameId,
	}));

	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.SetLastGameId from app-account instead
	 * */
	export const updateLastGameId = createAction(
		`${ACTION_PREFIX} update last game id ${SYNC_SUFFIX}`,
		(gameId: string) => ({ gameId })
	);

	export const skip = createAction(`${ACTION_PREFIX} skip`);

	export const clear = createAction(`${ACTION_PREFIX} clear`);
}
